





















































































































import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';
import {Inject} from 'inversify-props';

import {Notify} from '@/utils/Notify';

import {LoraForwarder as LoraForwarderModel} from '@/model/lora/LoraForwarder';

import {ILoraForwardersService} from '@/services/lora/ILoraForwarders.service';
import {ILoraForwarderChirpStackService} from '@/services/lora/forwarder/ILoraForwarderChirpStackService.service';
import {ILoraForwarderLoriotService} from '@/services/lora/forwarder/ILoraForwarderLoriot.service';
import {ILoraForwarderUdpService} from '@/services/lora/forwarder/ILoraForwarderUdp.service';
import {ILoraForwarderBasicStationService} from '@/services/lora/forwarder/BasicStation/ILoraForwarderBasicStation.service';
import {ILoraForwarderStdService} from '@/services/lora/forwarder/ILoraForwarderStd.service';

import LoraForwardersStore from '@/store/lora/LoraForwarders.store';

import {BaseComponent} from '@/mixins/BaseComponent';
import LoraForwarderUdpSettings from '@/components/Lora/Forwarder/Udp/LoraForwarderUdpSettings.vue';
import LoraForwarderLoriotSettings from '@/components/Lora/Forwarder/Loriot/LoraForwarderLoriotSettings.vue';
import LoraForwarderChirpStackSettings
  from '@/components/Lora/Forwarder/ChirpStack/LoraForwarderChirpStackSettings.vue';
import LoraForwarderBasicStationSettings
  from '@/components/Lora/Forwarder/BasicStation/LoraForwarderBasicStationSettings.vue';
import LoraForwarderUdpInfo from '@/components/Lora/Forwarder/Udp/LoraForwarderUdpInfo.vue';
import LoraForwarderLoriotInfo from '@/components/Lora/Forwarder/Loriot/LoraForwarderLoriotInfo.vue';
import LoraForwarderChirpStackInfo from '@/components/Lora/Forwarder/ChirpStack/LoraForwarderChirpStackInfo.vue';
import LoraForwarderBasicStationInfo
  from '@/components/Lora/Forwarder/BasicStation/LoraForwarderBasicStationInfo.vue';
import LoraForwarderSelector from '@/components/Lora/Forwarder/LoraForwarderSelector.vue';
import LoraQuickInfo from '@/components/Lora/LoraQuickInfo.vue';

@Component({
  components: {
    LoraQuickInfo,
    LoraForwarderSelector,
    LoraForwarderUdpSettings,
    LoraForwarderUdpInfo,
    LoraForwarderLoriotSettings,
    LoraForwarderLoriotInfo,
    LoraForwarderChirpStackSettings,
    LoraForwarderChirpStackInfo,
    LoraForwarderBasicStationSettings,
    LoraForwarderBasicStationInfo,
  },
})
export default class LoraForwarderSettings extends Mixins<BaseComponent>(BaseComponent) {
  @Inject(Symbol.for('ILoraForwardersService'))
  private loraForwarderService!: ILoraForwardersService;

  @Inject(Symbol.for('ILoraForwarderUdpService'))
  private loraForwarderUdpService!: ILoraForwarderUdpService;

  @Inject(Symbol.for('ILoraForwarderLoriotService'))
  private loraForwarderLoriotService!: ILoraForwarderLoriotService;

  @Inject(Symbol.for('ILoraForwarderBasicStationService'))
  private loraForwarderBasicStationService!: ILoraForwarderBasicStationService;

  @Inject(Symbol.for('ILoraForwarderChirpStackService'))
  private loraForwarderChirpStackService!: ILoraForwarderChirpStackService;

  private loraForwardersStore: LoraForwardersStore = getModule(LoraForwardersStore, this.$store);

  private selectedForwarder: LoraForwarderModel | null = null;

  private enabling = false;

  private activeForwarderEditor = false;

  private forwardersInfoComponent = {
    'udp-packet-forwarder': 'lora-forwarder-udp-info',
    'loriot-packet-forwarder': 'lora-forwarder-loriot-info',
    'chirpstack-gateway-bridge': 'lora-forwarder-chirp-stack-info',
    'lora-basic-station': `lora-forwarder-basic-station-info`,
  };

  private forwardersSettingsComponents = {
    'udp-packet-forwarder': 'lora-forwarder-udp-settings',
    'loriot-packet-forwarder': 'lora-forwarder-loriot-settings',
    'chirpstack-gateway-bridge': 'lora-forwarder-chirp-stack-settings',
    'lora-basic-station': 'lora-forwarder-basic-station-settings',
  };

  // @ts-ignore
  private forwardersServices: Map<string, ILoraForwarderStdService> = new Map([
    ['udp-packet-forwarder', this.loraForwarderUdpService],
    ['loriot-packet-forwarder', this.loraForwarderLoriotService],
    ['chirpstack-gateway-bridge', this.loraForwarderChirpStackService],
    ['lora-basic-station', this.loraForwarderBasicStationService],
  ]);

  get Version(): string | undefined {
    return this.loraForwardersStore.ActiveForwarder?.Version;
  }

  private async mounted() {
    await this.refresh();
    await this.refreshVersion();
  }

  private async refresh() {
    this.logger.info(`Getting active forwarder...`);
    this.setLoading();

    try {
      await this.loraForwardersStore.fetchActiveForwarder();
    } catch (error) {
      Notify.Error(this.logger, `Could not get active forwarder`, error);
    } finally {
      this.setLoaded();
    }
  }

  private async refreshVersion() {
    this.logger.trace(`Fetching active forwarder version`);

    if (!this.loraForwardersStore.ActiveForwarder) {
      this.logger.info(`Version fetch ignored, no active forwarder`);
      return;
    }

    const loraForwarderGenericService = this.forwardersServices.get(this.loraForwardersStore.ActiveForwarder.Id);

    try {

      if (!loraForwarderGenericService) {
        throw new Error(`unsupported forwarder '${this.loraForwardersStore.ActiveForwarder.Id}'`);
      }

      this.loraForwardersStore.setActiveForwarderVersion(await loraForwarderGenericService.getVersion());
      this.logger.trace(`Active forwarder version fetched`, this.loraForwardersStore.ActiveForwarder.Version);

    } catch (error) {
      Notify.Error(this.logger, `Could not get version`, error);
    }
  }

  private async enable() {

    if (!this.selectedForwarder) {
      Notify.Error(this.logger, `Could not enable forwarder: no forwarder selected`);
      return;
    }

    if (this.selectedForwarder.Id === this.loraForwardersStore.ActiveForwarder?.Id) {
      this.activeForwarderEditor = false;
      return;
    }

    this.enabling = true;

    try {
      this.logger.info(`Settings active LoRa forwarder to:`, this.selectedForwarder);

      await this.loraForwarderService.setActive(this.selectedForwarder.Id);
      this.loraForwardersStore.setActiveForwarder(this.selectedForwarder);
      this.activeForwarderEditor = false;
    } catch (error) {
      Notify.Error(this.logger, `Could not set active LoRa forwarder`, error);
    } finally {
      this.enabling = false;
    }

    this.refreshVersion();
  }
}
